import SalaryCalculationGroupComponent from "../components/SalaryCalculationGroup";
import useSalaryCalculationGroup from "../hooks/useSalaryCalculationGroup";

const SalaryCalculationGroup = () => {
    const SalaryCalculationGroupProps = useSalaryCalculationGroup();
    return <SalaryCalculationGroupComponent {...SalaryCalculationGroupProps} />;
};

export default SalaryCalculationGroup;
